import { GithubSecurityPipelineAssignSpaces } from "../../SecurityPipelineGithubOrgPage/components/SecurityPipelineGithubAssignSpaces/GithubSecurityPipelineAssignSpaces";
import { Box } from "@mui/material";
import { Command } from "~/components/guides/components/command";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material";

export interface SecurityPipelineGithubSetupStepThreeProps {
  repositories: {
    link: string;
    fullName: string;
  }[];
  onChangePairing: () => void;
  pairedSpacesNames: string[];
}

export const SecurityPipelineGithubSetupStepThree = ({
  repositories,
  onChangePairing,
  pairedSpacesNames,
}: SecurityPipelineGithubSetupStepThreeProps) => {
  const theme = useTheme();
  return (
    <Box pb={4} sx={{ opacity: repositories.length === 0 ? 0.2 : 1 }}>
      <Command
        number={3}
        options={{
          fontSize: { xs: 16 },
          dotColor: theme.palette.background.lightest,
        }}
      >
        Pair spaces with security repos to protect them
      </Command>

      <Box sx={{ pl: 6 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, mt: 2 }}
        >
          This enables spaces to automatically remediate findings, and schedule
          remediations.
        </Typography>
        <GithubSecurityPipelineAssignSpaces
          onChangePairing={onChangePairing}
          pairedSpaces={pairedSpacesNames}
        />
      </Box>
    </Box>
  );
};
